export const apiProxy = {
  '/p2p/': 'https://www.madailicai.com',
  '/backstreet/': 'https://www.madailicai.com',
  '/cms-web-api/': 'https://www.madailicai.com'
}

export const jkUrl = 'https://jk.chinatopcredit.com'



// WEBPACK FOOTER //
// ./settings/index.js